import { render, staticRenderFns } from "./print-sums.vue?vue&type=template&id=e741ee84&"
import script from "./print-sums.vue?vue&type=script&lang=ts&"
export * from "./print-sums.vue?vue&type=script&lang=ts&"
import style0 from "./print-sums.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
